import { post, get, setCsrfToken } from '@services/method';
import * as routes from '@configs/routes.json';
import { IPermission } from '@models/user';

export interface IUserDto {
  firstName: string;
  lastName: string;
  email: string;
  institution?: string;
  language?: string;
  hasValidTOS?: boolean;
  adaptiveSuperUser: boolean;
  permissions: IPermission[];
}

export const authenticate = (
  email: string,
  password: string
): Promise<IUserDto> => {
  return post(routes.api.auth.authenticate, {
    init: {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        password,
      }),
    },
    skipAuthorizationHandler: true,
  }).then((response: Response) => response.json());
};

export const logout = (): Promise<void> => {
  return post(routes.api.auth.logout).then(() => {});
};

export const isAuthenticated = (): Promise<IUserDto | undefined> => {
  return get(routes.api.auth.isAuthenticated)
    .then((response: Response) => response.json())
    .then((data: { isAuthenticated: boolean; user: IUserDto }) => {
      if (data.isAuthenticated) {
        return data.user;
      }

      return undefined;
    });
};

export const csrfToken = (): Promise<void> => {
  return get(routes.api.csrfToken)
    .then((response: Response) => response.text())
    .then((token: string) => {
      setCsrfToken(token);
      return;
    });
};

export const notification = (): Promise<string | undefined> => {
  return get(routes.api.login.notification).then((response: Response) =>
    response.text()
  );
};

export const marketingMessage = (): Promise<string> => {
  return get(routes.api.login.marketingMessage).then((response: Response) =>
    response.text()
  );
};

export const helpContent = (): Promise<string> => {
  return get(routes.api.content.help).then((response: Response) =>
    response.text()
  );
};
